import React from 'react';
import { createComponent } from '@lit/react';
import { NotificationBanner } from '../../utils/fundationUiKit';

const NotificationBannerComponent = createComponent({
  tagName: 'notification-banner',
  elementClass: NotificationBanner,
  react: React,
  events: {
    onClose: 'close',
  },
});

export default NotificationBannerComponent;
